<template>
  <Component
    :is="tag"
    v-if="!text"
    :contenteditable="editing"
    :placeholder="placeholder"
    @paste="handlepaste"
    @input="emit('input', $event)"
    @blur="emit('blur', $event)"
  ></Component>
  <div v-else v-text="text"></div>
</template>

<script setup>
defineProps({
  tag: {
    type: String,
    default: 'div',
  },
  editing: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  text: {
    type: [String, Number],
    default: '',
  },
});
const emit = defineEmits(['input', 'blur']);
const handlepaste = (e) => {
  document.execCommand(
    'insertText',
    false,
    e.clipboardData.getData('text/plain'),
  );
  e.preventDefault();
};
</script>
